import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { RandomOverlay } from '../auth/overlays';
import '../auth/auth.scss';

const AuthLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.from === 'register' && location.state?.token) {
      navigate(`/register?token=${location.state?.token}`, {
        replace: true,
        state: null,
      });
      return;
    }
  }, [location, navigate]);

  return (
    <div className="auth-layout">
      <div
        className="auth-layout__bg"
        style={{
          backgroundImage:
            'url(https://dcyisegnqdilsvkazjch.supabase.co/functions/v1/content-image?type=landing_background&format=redirect)',
        }}
      />
      <div className="auth-layout__overlay" />
      <RandomOverlay />
      <div className="auth-layout__content">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
